import { gatewayApi } from './api';

const ORG_INFO = '/v1/tenancy/organizations/info';
const ORG_MODULES = '/v1/tenancy/organizations/modules';
const MEMBERS = '/v1/tenancy/members';
const AUDIT_EVENTS = '/v1/tenancy/audit-events';

const unwrap = (response) => response.data?.data ?? response.data;

export const organizationService = {
  getInfo: async () => {
    const response = await gatewayApi.get(ORG_INFO);
    return unwrap(response);
  },

  updateInfo: async (payload) => {
    const response = await gatewayApi.patch(ORG_INFO, payload);
    return unwrap(response);
  },

  listModules: async () => {
    const response = await gatewayApi.get(ORG_MODULES);
    return unwrap(response);
  },

  listMembers: async () => {
    const response = await gatewayApi.get(MEMBERS);
    return unwrap(response);
  },

  provisionMember: async (payload) => {
    const response = await gatewayApi.post(MEMBERS, payload, {
      headers: { 'x-request-id': window.crypto?.randomUUID?.() || `req-${Date.now()}` },
    });
    return unwrap(response);
  },

  updateMember: async (memberId, payload) => {
    const response = await gatewayApi.patch(`${MEMBERS}/${memberId}`, payload, {
      headers: { 'x-request-id': window.crypto?.randomUUID?.() || `req-${Date.now()}` },
    });
    return unwrap(response);
  },

  resendInvite: async (memberId) => {
    const response = await gatewayApi.post(`${MEMBERS}/${memberId}/resend-invite`, undefined, {
      headers: { 'x-request-id': window.crypto?.randomUUID?.() || `req-${Date.now()}` },
    });
    return unwrap(response);
  },

  listAuditEvents: async ({
    limit = 50,
    cursor,
    action,
    actorType,
    actorId,
    outcome,
    resourceType,
    resourceId,
    dateFrom,
    dateTo,
  } = {}) => {
    const params = new URLSearchParams();
    if (limit) params.append('limit', String(limit));
    if (cursor) params.append('cursor', cursor);
    if (action) params.append('action', action);
    if (actorType) params.append('actorType', actorType);
    if (actorId) params.append('actorId', actorId);
    if (outcome) params.append('outcome', outcome);
    if (resourceType) params.append('resourceType', resourceType);
    if (resourceId) params.append('resourceId', resourceId);
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);

    const query = params.toString();
    const response = await gatewayApi.get(query ? `${AUDIT_EVENTS}?${query}` : AUDIT_EVENTS);
    return unwrap(response);
  },
};

export default organizationService;
